import { InstitutionalIndicationOrderType } from '../../../../graphql';

export const demandStatusLabels = {
  interested: 'Interested',
  pass: 'Pass',
} as const;

export type DemandStatus = (typeof demandStatusLabels)[keyof typeof demandStatusLabels];

export const getDemandStatus = (type: InstitutionalIndicationOrderType): DemandStatus =>
  type === InstitutionalIndicationOrderType.Pass
    ? demandStatusLabels.pass
    : demandStatusLabels.interested;
